var app = angular.module("leonardo");

var ReportsUnsubscribe = function($scope, $stateParams, ScheduleService) {

  $scope.showMessage = false;
  ScheduleService.unsubscribe($stateParams.token).then(function () {
    $scope.showMessage = true;
  });

};

app.controller('ReportsUnsubscribe', ['$scope', '$stateParams', 'ScheduleService', ReportsUnsubscribe]);
